import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import service_bg from './../../assets/service_bg.png'
import img1 from './../../assets/Frame_11712756882.png'
import img2 from './../../assets/Frame_11712756884.png'
import img3 from './../../assets/Frame_11712756885.png'
import img4 from './../../assets/unsplash_R10-3wYGgEE.png'
import img5 from './../../assets/unsplash_Q80LYxv_Tbs.png'
import img6 from './../../assets/unsplash_mBVDBC-JgCc.png'
import icon1 from './../../assets/icons8_idea.png'
import icon2 from './../../assets/carbon_task-tools.png'
import icon3 from './../../assets/garden_security-26.png'
import icon4 from './../../assets/fluent_people-community-12-filled.png'

function Training() {
  return (
    <div className='wrap-hidden'>
      <div className='pb-5 pt-5'
        style={{
          backgroundImage: `url(${service_bg})`,
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "100% auto",
        }}
      >
        <Container className='mt-5 pt-5 pb-5'>
          <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
            <div className='mt-5 header text-center'><span className="text-brand-secondary">Training</span> & Certification</div>
            <p className='mt-4 text-center'><strong>Building Cyber Champions One Mind at a Time</strong></p>
            <p className='mt-4 text-center'>At Siberwander, we don’t just deliver training, we create transformative learning experiences that empower individuals and teams to lead with confidence in a cyber-driven world. Whether you’re a frontline staff, digital native, or future CISO, our programs are crafted to turn knowledge into action, curiosity into capability, and awareness into real world resilience.</p>
            <br/>
            <p className='text-center'>Cybersecurity is no longer just for IT. It’s for everyone who touches a screen, manages data, or makes decisions and our mission is to make that skillset accessible, engaging, and truly unforgettable.</p>
          </AnimationOnScroll>

          <div className='mt-5 card-shadow'>
            <div className='bg-main-secondary-light pt-5 pb-5 ps-2 pe-2'>
              <div className='header text-center'>Our <span className="text-brand-secondary">Programs</span></div>
            </div>
            <div className='p-5 category ps-5 pe-5'>
              <Row className='align-items-center'>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Cybersecurity for <span className="text-brand-secondary">Professionals</span></strong></h4>
                    <div className='mt-3'><strong>From marketing to finance, from oTurn Everyday Roles Into Everyday Defenders.</strong></div>
                    <p className='text-justify'>From marketing to finance, from operations to healthcare cyber threats don’t discriminate, and neither should cybersecurity skills. This track empowers non-IT professionals with the instincts, reflexes, and digital awareness needed to stay ahead of modern attacks. You’ll learn how to identify suspicious behavior, secure your work tools, protect sensitive data, and become the first and strongest line of defense in your organization, all without needing to “speak tech”.</p>
                    <br/>
                    <p className='text-justify'>Because in today’s workplace, security isn’t just IT’s job, it’s everyone’s responsibility. Operations to healthcare. We help non-IT roles develop practical cyber instincts. Learn to identify digital threats, handle tools securely, and become your team’s first line of defense.</p>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img1} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
              </Row>
              <Row className='align-items-center mt-5'>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img2} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Cybersecurity for the <span className="text-brand-secondary">Public</span></strong></h4>
                    <div className='mt-3'><strong>Cyber Hygiene Meets Real-Life Relevance.</strong></div>
                    <p className='text-justify'>This interactive, beginner friendly program is built for everyday internet users from students and job seekers to content creators and career switchers. We make cybersecurity accessible, engaging, and unexpectedly fun, covering essentials like secure browsing, safe passwords, social engineering, and how to spot red flags in daily digital life. With lifetime access to our community, practical resources, and an exclusive Networking Night, this isn’t just training, it’s your entry ticket to a smarter digital future.</p>
                    <br/>
                    <p className='text-justify'>Because every click, swipe, and share deserves protection.</p>
                  </AnimationOnScroll>
                </Col>
              </Row>
              <Row className='align-items-center mt-4'>
                <Col xs={12} md={5} className='mb-3'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <h4><strong>Training + Site <span className="text-brand-secondary">Expedition</span></strong></h4>
                    <div className='mt-3'><strong>Cybersecurity, Up Close and Personal.</strong></div>
                    <p className='text-justify'>Why just learn about cybersecurity, when you can see it in action? This immersive program blends in depth training with guided visits to top tier cybersecurity companies. Giving participants rare access to enterprise grade systems, real world security ops, and candid sessions with global experts. You’ll train like a pro, travel like a VIP, and return with practical insights, professional connections, and a whole new perspective on how the world’s digital backbone is protected.</p>
                    <br/>
                    <p className='text-justify'>All inclusive. All access. No fluff. Just real learning from the frontlines of cyber defense.</p>
                  </AnimationOnScroll>
                </Col>
                <Col xs={12} md={1}/>
                <Col xs={12} md={6} className='mb-3 text-center'>
                  <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                    <img src={img3} style={{width:'100%'}} alt=""/>
                  </AnimationOnScroll>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>
      <Container className='pb-5 mt-5'>
        <Row>
          <Col xs={12} md={5} className='mb-4'></Col>
          <Col xs={12} md={1}/>
          <Col xs={12} md={6}>
            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
              <div className='header ps-4 pe-5'>What You’ll <span className="text-brand-secondary">Master</span></div>
            </AnimationOnScroll>
          </Col>
        </Row>
        <div className="card-shadow bg-main-secondary-light mt-3" style={{overflow:"unset"}}>
          <Row>
            <Col xs={12} md={6} className='mb-4'>
              <div className='img-master-wrapper non-mobile'>
                <div 
                  className='img-master'
                  style={{
                    backgroundImage: `url(${img4})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                  }}
                />
              </div>
            </Col>
            <Col xs={12} md={6}>
              <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                <div className='pt-4 pb-4 pe-4 ps-4' style={{overflow:'visible'}}>
                  <div className='mt-3'><strong>Inside the Experience: What You Actually Get to Touch, Break, and Master.</strong></div>
                  <p className='text-justify'>Our training goes beyond slides and simulations we offer real-world, hands-on immersion into enterprise-grade cloud security stacks. Participants interact with the very technologies that power today’s most resilient cloud infrastructures guided by experts who’ve seen breaches before they made headlines.</p>
                  <br/>
                  <p className='text-justify'>You won’t just learn acronyms. You’ll understand the architecture, feel the workflows, and think like a defender in motion.</p>
                  <div className='mt-3'><strong>Explore tools and frameworks like:</strong></div>
                  <ul>
                    <li>
                      <strong>Cloud Security Posture Management (CSPM)</strong>
                      <p>Get full visibility and compliance insights across your cloud assets.</p>
                    </li>
                    <li>
                      <strong>Cloud Infrastructure Entitlement Management (CIEM)</strong>
                      <p>Learn how to prevent identity sprawl and manage access at scale.</p>
                    </li>
                    <li>
                      <strong>Cloud Workload Protection Platform (CWPP)</strong>
                      <p>Discover how to secure apps, containers, and workloads without breaking build pipelines.</p>
                    </li>
                    <li>
                      <strong>Kubernetes Security Posture Management (KSPM)</strong>
                      <p>Understand how to secure clusters, containers, and control planes.</p>
                    </li>
                    <li>
                      <strong>Cloud Data Security</strong>
                      <p>Classify, encrypt, and monitor sensitive data across your cloud from buckets to databases, with full audit readiness.</p>
                    </li>
                    <li>
                      <strong>Cloud Detection & Response (CDR)</strong>
                      <p>Detect, prioritize, and respond to live threats in dynamic environments.</p>
                    </li>
                    <li>
                      <strong>Cloud Network & API Security</strong>
                      <p>Lock down your connections without slowing down your innovation.</p>
                    </li>
                  </ul>
                </div>
              </AnimationOnScroll>
            </Col>
          </Row>
        </div>
      </Container>
      <Container className='pb-5 mt-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} delay={0} offset={100}>
          <div className='header text-center'>Our Certification <span className="text-brand-secondary">Tracks</span></div>
        </AnimationOnScroll>
        <Row className='mt-4'>
          <Col xs={12} md={6} className='mb-4'>
            <Container className="timeline-container">
              <div className="timeline-line" />
              <Row className="timeline-event">
                <Col xs={12} className="d-flex position-relative">
                  <div className="timeline-dot" />
                  <div className="timeline-box">
                    <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={0} offset={100}>
                      <h5>Foundational Essentials<br/>(CSCU, E|HE, N|DE)</h5>
                      <div className="mt-3"><strong>Where Awareness Begins and Bad Habits End.</strong></div>
                      <p className="text-justify">This track transforms everyday users into digitally conscious defenders. Whether you're in marketing, finance, HR, or fresh out of college — we equip you with cyber hygiene fundamentals, clear understanding of real-world threats, and the digital habits to protect your data, devices, and identity in today’s threat-filled world.</p>
                      <br/>
                      <p className="text-justify"><strong>Perfect for:</strong> students, non-IT professionals, business users, and anyone tired of clicking the wrong link.</p>
                    </AnimationOnScroll>
                  </div>
                </Col>
              </Row>
              <Row className="timeline-event">
                <Col xs={12} className="d-flex position-relative">
                  <div className="timeline-dot" />
                  <div className="timeline-box">
                    <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={50} offset={100}>
                      <h5>Professional Hacking or Forensics<br/>(CEH, ECSA, LPT/C|PENT, CHFI, E|CIH)</h5>
                      <div className="mt-3"><strong>Master the Mindset of the Attacker. Then Dismantle It.</strong></div>
                      <p className="text-justify">This is where practitioners evolve into specialists. Dive into offensive security, ethical hacking, digital forensics, and incident response using real-world tools and attack simulations. You'll learn how modern breaches unfold — and how to stop them, trace them, and report them with confidence.</p>
                      <br/>
                      <p className="text-justify"><strong>Ideal for:</strong> SOC analysts, security engineers, IT warriors, and anyone making the jump from reactive to proactive.</p>
                    </AnimationOnScroll>
                  </div>
                </Col>
              </Row>
              <Row className="timeline-event">
                <Col xs={12} className="d-flex position-relative">
                  <div className="timeline-dot" />
                  <div className="timeline-box">
                    <AnimationOnScroll animateOnce={true} animateIn="animate__slideInLeft" duration={.8} animatePreScroll={true} delay={100} offset={100}>
                      <h5>Management of Cybersecurity<br/>(C|CISO)</h5>
                      <div className="mt-3"><strong>From Managing Threats to Managing Strategy.</strong></div>
                      <p className="text-justify">This elite track is designed for those who protect not just networks but reputations. Gain the skills to build cybersecurity programs, drive compliance, lead crisis response, and align security with business impact. Because today's CISO doesn't just understand risk they translate it into boardroom decisions.</p>
                      <br/>
                      <p className="text-justify"><strong>Best for:</strong> C-level leaders, IT decision-makers, and security professionals ready to lead at scale.</p>
                    </AnimationOnScroll>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col xs={12} md={6} className='mb-4'>
            <div 
              style={{
                backgroundImage: `url(${img5})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                width: "100%",
                height: "100%",
                borderRadius: "20px"
              }}
            />
          </Col>
        </Row>
      </Container>
      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center'>Our Certification <span className="text-brand-secondary">Topics</span></div>
          <p className='mt-4 text-center'><strong>Explore Our Certification Domains</strong></p>
          <p className='mt-4 text-center'><strong>Designed for every role, every level, and every ambition.</strong></p>
          <p className='text-center'>From foundational know how to expert level mastery, our curriculum is built to shape the next generation of cybersecurity defenders, decision makers, and disruptors.</p>
        </AnimationOnScroll>
        <Row className='mt-4'>
          <Col xs={12} md={6} className='mb-4'>
            <div 
              style={{
                backgroundImage: `url(${img6})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                width: "100%",
                height: "100%",
                borderRadius: "20px"
              }}
            />
          </Col>
          <Col xs={12} md={6} className='mb-4'>
            <Accordion className='topic-wrapper'>
              <Accordion.Item eventKey="0" className="mb-2">
                <Accordion.Header>Foundation / Essentials</Accordion.Header>
                <Accordion.Body>
                  <strong>Start Smart. Stay Secure.</strong>
                  <p>For those entering the cyber arena or seeking to build strong digital fundamentals.</p>
                  <ul>
                    <li>Certified Secure Computer User (CSCU)</li>
                    <li>Ethical Hacking Essentials (E|HE) </li>
                    <li>Network Defense Essentials (N|DE) </li>
                    <li>Digital Forensics Essentials (D|FE) </li>
                    <li>DevSecOps Essentials (D|SE) </li>
                    <li>Cloud Security Essentials (C|SE) </li>
                    <li>IoT Security Essentials (I|SE) </li>
                    <li>Threat Intelligence Essentials (T|IE) </li>
                    <li>SOC Essentials (S|CE)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1" className="mb-2">
                <Accordion.Header>Vulnerability Assessment & Penetration Testing</Accordion.Header>
                <Accordion.Body>
                  <strong>Think Like a Hacker. Defend Like a Strategist.</strong>
                  <p>Learn to discover, exploit, and secure vulnerabilities ethically and effectively.</p>
                  <ul>
                    <li>Certified Ethical Hacker (C|EH)</li>
                    <li>CEH (Master)</li>
                    <li>Certified Security Analyst (ECSA)</li>
                    <li>Licensed Penetration Tester (LPT)</li>
                    <li>Certified Penetration Testing Professional (C|PENT)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" className="mb-2">
                <Accordion.Header>Cyber Forensics & Incident Response</Accordion.Header>
                <Accordion.Body>
                  <strong>Track the Breach. Uncover the Truth. Restore Control.</strong>
                  <p>Master digital forensics, threat containment, and post-incident strategy.</p>
                  <ul>
                    <li>Computer Hacking Forensic Investigator (CHFI)</li>
                    <li>Certified Incident Handler (E|CIH)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4" className="mb-2">
                <Accordion.Header>Network Defense & Operations</Accordion.Header>
                <Accordion.Body>
                  <strong>Secure the Core. Fortify the Edge.</strong>
                  <p>Defend critical infrastructure and monitor live threats with precision.</p>
                  <ul>
                    <li>Certified Network Defender (C|ND)</li>
                    <li>ICS/SCADA Cybersecurity</li>
                    <li>Certified SOC Analyst (C|SA)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5" className="mb-2">
                <Accordion.Header>Software & Application Security</Accordion.Header>
                <Accordion.Body>
                  <strong>Code it. Secure it. Own it.</strong>
                  <p>Develop secure applications and understand encryption like an architect.</p>
                  <ul>
                    <li>Certified Application Security Engineer (CASE)</li>
                    <li>Certified Encryption Specialist (ECES)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6" className="mb-2">
                <Accordion.Header>Governance, Risk & Compliance (GRC)</Accordion.Header>
                <Accordion.Body>
                  <strong>Lead the Program. Own the Risk. Align the Business.</strong>
                  <p>Become fluent in cybersecurity governance, compliance mandates, and risk strategy.</p>
                  <ul>
                    <li>Associate/Certified Chief Information Security Officer (C|CISO) </li>
                    <li>Disaster Recovery Professional (EDRP) </li>
                    <li>Certified Threat Intelligence Analyst (CTIA)</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7" className="mb-2">
                <Accordion.Header>Specialist & Technical Tracks</Accordion.Header>
                <Accordion.Body>
                  <strong>Niche Expertise. Real-World Relevance.</strong>
                  <p>Deep-dive into specialized roles that power modern cyber defense.</p>
                  <ul>
                    <li>Certified Cybersecurity Technician (C|CT) </li>
                    <li>Certified Encryption Specialist (ECES) </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
      <Container className='pb-5'>
        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={100}>
          <div className='header text-center'>Why Choose  <span className="text-brand-secondary">Siberwander?</span></div>
          <p className='mt-4 text-center'><strong>Built for Practitioners. Designed for Progress. Powered by Community.</strong></p>
        </AnimationOnScroll>
        <div className='card-shadow mt-4 bg-main-secondary-light'>
          <div className='category ps-5 pe-5 pt-4'>
            <Row>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon1} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Effortless, Impactful Learning</strong></div>
                    <p className='text-center mt-2'>We use simplified, modern formats no boring theory dumps. Just clear, engaging content that sticks.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={100} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon2} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Real Tools. Real Scenarios. Real Readiness.</strong></div>
                    <p className='text-center mt-2'>Train with the same use cases and toolsets used by professionals in real-world environments.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={150} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon3} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Agentless-First Security Perspective</strong></div>
                    <p className='text-center mt-2'>Get ahead with a modern, frictionless approach to cloud security built for scale, speed, and visibility.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
              <Col md={3} xs={12} className='mb-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true} delay={0} offset={100} style={{height:"100%"}}>
                  <div className='card-shadow p-3 pt-4 pb-4 text-center' style={{ borderRadius:15, height: "100%" }}>
                    <img src={icon4} style={{width:"50px", height: "50px"}} alt=""/>
                    <div className='text-center mt-1'><strong>Community-Driven Ecosystem</strong></div>
                    <p className='text-center mt-2'>Grow with a network of learners, mentors, and practitioners because cybersecurity is stronger when shared.</p>
                  </div>
                </AnimationOnScroll>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Training